import styled from "styled-components";

export const Footer = styled.div`
  /* position: fixed;
  bottom: 0; */
  width: 100%;
  padding: 5px;
  z-index: 1;

  font-size: 12px;
  text-shadow: 0px 0px 5px black;
  text-align: center;
  background-color: var(--overlayLight);
  color: var(--white);
`;
